import React, { createContext, useCallback, useContext, useState } from 'react';
import '../App.css';

const NotifyContext = createContext(null);

let idSeq = 0;
function nextId() {
  idSeq += 1;
  return idSeq;
}

export function NotifyProvider({ children }) {
  const [items, setItems] = useState([]);

  const remove = useCallback((id) => {
    setItems((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const push = useCallback(
    (variant, message) => {
      const id = nextId();
      const text = message != null ? String(message) : '';
      setItems((prev) => [...prev, { id, variant, message: text }]);
      window.setTimeout(() => remove(id), 6500);
    },
    [remove]
  );

  const showSuccess = useCallback((m) => push('success', m), [push]);
  const showError = useCallback((m) => push('error', m), [push]);
  const showInfo = useCallback((m) => push('info', m), [push]);

  const value = { showSuccess, showError, showInfo, remove };

  return (
    <NotifyContext.Provider value={value}>
      {children}
      <div className="app-toast-stack" aria-live="polite" aria-relevant="additions">
        {items.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`app-toast app-toast--${t.variant}`}
            onClick={() => remove(t.id)}
          >
            <span className="app-toast__text">{t.message}</span>
            <span className="app-toast__dismiss" aria-hidden>
              ×
            </span>
          </button>
        ))}
      </div>
    </NotifyContext.Provider>
  );
}

export function useNotify() {
  const ctx = useContext(NotifyContext);
  if (!ctx) {
    throw new Error('useNotify must be used within NotifyProvider');
  }
  return ctx;
}
